module.exports = require("@web3auth/torus-solana-adapter");